import { asve } from './orve';
import { shuffleArray } from './report-util';
import { getAssessmentCutoffs, getCodesCutoffs } from '../../../api/assessments-api';
import { REPORT_TYPE } from '../../../utils/constants';

const ASSESSMENT_RESOURCES_MAP = {};
const CODE_RESOURCES_MAP = {};
const DEFAULT_COMPETENCIES_ASSESSMENT_ID = 7;
const DEFAULT_INTERVIEW_ASSESSMENT_ID = 8;

const getDefaultCompetenciesOverallTextLocalResource = (target) => {
  const localResources = asve(target);

  return localResources.competencies;
};

const getDefaultCompetenciesTitle = (key) => {
  switch (key) {
    case 'BCT':
    case 'INTERVIEW_1':
      return 'Building Cohesive Teams';
    case 'BRT':
    case 'INTERVIEW_2':
      return 'Building Resilient Teams';
    case 'CCI':
    case 'INTERVIEW_3':
      return 'Creating a Climate of Inclusion';
    case 'CSB':
    case 'INTERVIEW_4':
      return 'Creating a Sense of Belonging';
    case 'HJF':
    case 'INTERVIEW_5':
      return 'Hiring for Job Fit';
    case 'MRW':
    case 'INTERVIEW_6':
      return 'Managing a Remote Workforce';
    case 'MTC':
    case 'INTERVIEW_7':
      return 'Managing Through a Crisis';
    case 'DT':
    case 'INTERVIEW_8':
      return 'Developing Talent';
    case 'EFR':
    case 'INTERVIEW_9':
      return 'Executing for Results';
    case 'MSD':
    case 'INTERVIEW_10':
      return 'Making Sound Decisions';
  }
};

const getDefaultCompetenciesSummary = (target, key) => {
  const localResources = asve(target);

  switch (key) {
    case 'BCT':
    case 'INTERVIEW_1':
      return localResources.competenciesBuildingCohesiveTeams;
    case 'BRT':
    case 'INTERVIEW_2':
      return localResources.competenciesBuildingResilientTeams;
    case 'CCI':
    case 'INTERVIEW_3':
      return localResources.competenciesCreatingClimateOfInclusion;
    case 'CSB':
    case 'INTERVIEW_4':
      return localResources.competenciesCreatingSenseOfBelonging;
    case 'HJF':
    case 'INTERVIEW_5':
      return localResources.competenciesHiringForJobFit;
    case 'MRW':
    case 'INTERVIEW_6':
      return localResources.competenciesManagingRemoteWorkForce;
    case 'MTC':
    case 'INTERVIEW_7':
      return localResources.competenciesManagingThroughCrisis;
    case 'DT':
    case 'INTERVIEW_8':
      return localResources.competenciesDevelopingTalent;
    case 'EFR':
    case 'INTERVIEW_9':
      return localResources.competenciesExecutingForResults;
    case 'MSD':
    case 'INTERVIEW_10':
      return localResources.competenciesMakingSoundDecisions;
  }
};

const getDefaultCompetenciesTips = (target, key, reportType) => {
  const localResources = asve(target);

  switch (key) {
    case 'BCT':
    case 'INTERVIEW_1':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesBuildingCohesiveTeamsTips)
        : shuffleArray(target, localResources.competenciesBuildingCohesiveTeamsTips);
    case 'BRT':
    case 'INTERVIEW_2':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesBuildingResilientTeamsTips)
        : shuffleArray(target, localResources.competenciesBuildingResilientTeamsTips);
    case 'CCI':
    case 'INTERVIEW_3':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesCreatingClimateOfInclusionTips)
        : shuffleArray(target, localResources.competenciesCreatingClimateOfInclusionTips);
    case 'CSB':
    case 'INTERVIEW_4':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesCreatingSenseOfBelongingTips)
        : shuffleArray(target, localResources.competenciesCreatingSenseOfBelongingTips);
    case 'HJF':
    case 'INTERVIEW_5':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesHiringForJobFitTips)
        : shuffleArray(target, localResources.competenciesHiringForJobFitTips);
    case 'MRW':
    case 'INTERVIEW_6':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesManagingRemoteWorkforceTips)
        : shuffleArray(target, localResources.competenciesManagingRemoteWorkforceTips);
    case 'MTC':
    case 'INTERVIEW_7':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesManagingThroughCrisisTips)
        : shuffleArray(target, localResources.competenciesManagingThroughCrisisTips);
    case 'DT':
    case 'INTERVIEW_8':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesDevelopingTalentTips)
        : shuffleArray(target, localResources.competenciesDevelopingTalentTips);
    case 'EFR':
    case 'INTERVIEW_9':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesExecutingForResultsTips)
        : shuffleArray(target, localResources.competenciesExecutingForResultsTips);
    case 'MSD':
    case 'INTERVIEW_10':
      return reportType === REPORT_TYPE.development
        ? shuffleArray(target, localResources.developmentCompetenciesMakingSoundDecisionsTips)
        : shuffleArray(target, localResources.competenciesMakingSoundDecisionsTips);
  }
};
export const retrieveCompetenciesCutoffs = async (auth, target) => {
  const assessmentId = target.selfCompetencies?.assessmentId;
  if (assessmentId) {
    if (!ASSESSMENT_RESOURCES_MAP[assessmentId]) {
      ASSESSMENT_RESOURCES_MAP[assessmentId] = {};
      ASSESSMENT_RESOURCES_MAP[assessmentId].assessmentCutoffs = await getAssessmentCutoffs(auth, assessmentId);
      const questionCodes = [];
      target.selfCompetencies.variableKeys.forEach((key) => {
        questionCodes.push(key + '_S');
      });
      const questionCutoffs = await getCodesCutoffs(auth, assessmentId, questionCodes);
      CODE_RESOURCES_MAP[assessmentId] = {};
      const assessmentCodeResources = CODE_RESOURCES_MAP[assessmentId];
      Object.keys(questionCutoffs).forEach((key) => {
        assessmentCodeResources[key] = questionCutoffs[key];
      });
    }
  }
};

export const retrieveExperienceCutoffs = async (auth, target) => {
  const assessmentId = target.experience?.assessmentId;
  if (assessmentId) {
    if (!ASSESSMENT_RESOURCES_MAP[assessmentId]) {
      const assessmentCutoffs = await getAssessmentCutoffs(auth, assessmentId);
      if (assessmentCutoffs.breakpoints) {
        ASSESSMENT_RESOURCES_MAP[assessmentId] = {};
        ASSESSMENT_RESOURCES_MAP[assessmentId].assessmentCutoffs = await getAssessmentCutoffs(auth, assessmentId);
        const questionCodes = [];
        target.experience.variableKeys.forEach((key) => {
          questionCodes.push(key);
        });
        const questionCutoffs = await getCodesCutoffs(auth, assessmentId, questionCodes);
        CODE_RESOURCES_MAP[assessmentId] = {};
        const assessmentCodeResources = CODE_RESOURCES_MAP[assessmentId];
        Object.keys(questionCutoffs).forEach((key) => {
          assessmentCodeResources[key] = questionCutoffs[key];
        });
      }
    }
  }
};

export const retrieveSituationalJudgmentCutoffs = async (auth, target) => {
  const assessmentId = target.situationalJudgment?.assessmentId;
  if (assessmentId) {
    if (!ASSESSMENT_RESOURCES_MAP[assessmentId]) {
      const assessmentCutoffs = await getAssessmentCutoffs(auth, assessmentId);
      if (assessmentCutoffs.breakpoints) {
        ASSESSMENT_RESOURCES_MAP[assessmentId] = {};
        ASSESSMENT_RESOURCES_MAP[assessmentId].assessmentCutoffs = await getAssessmentCutoffs(auth, assessmentId);
        const questionCodes = [];
        target.situationalJudgment.variableKeys.forEach((key) => {
          questionCodes.push(key);
        });
        const questionCutoffs = await getCodesCutoffs(auth, assessmentId, questionCodes);
        CODE_RESOURCES_MAP[assessmentId] = {};
        const assessmentCodeResources = CODE_RESOURCES_MAP[assessmentId];
        Object.keys(questionCutoffs).forEach((key) => {
          assessmentCodeResources[key] = questionCutoffs[key];
        });
      }
    }
  }
};

export const retrieveValuesCutoffs = async (auth, target) => {
  const assessmentId = target.values?.assessmentId;
  if (assessmentId) {
    if (!ASSESSMENT_RESOURCES_MAP[assessmentId]) {
      const assessmentCutoffs = await getAssessmentCutoffs(auth, assessmentId);
      if (assessmentCutoffs.breakpoints) {
        ASSESSMENT_RESOURCES_MAP[assessmentId] = {};
        ASSESSMENT_RESOURCES_MAP[assessmentId].assessmentCutoffs = await getAssessmentCutoffs(auth, assessmentId);
        const questionCodes = [];
        target.values.variableKeys.forEach((key) => {
          questionCodes.push(key);
        });
        const questionCutoffs = await getCodesCutoffs(auth, assessmentId, questionCodes);
        CODE_RESOURCES_MAP[assessmentId] = {};
        const assessmentCodeResources = CODE_RESOURCES_MAP[assessmentId];
        Object.keys(questionCutoffs).forEach((key) => {
          assessmentCodeResources[key] = questionCutoffs[key];
        });
      }
    }
  }
};

export const retrieveInterviewCutoffs = async (auth, target) => {
  if (target.interviewCompetencies) {
    if (!ASSESSMENT_RESOURCES_MAP[DEFAULT_INTERVIEW_ASSESSMENT_ID]) {
      ASSESSMENT_RESOURCES_MAP[DEFAULT_INTERVIEW_ASSESSMENT_ID] = {};
      ASSESSMENT_RESOURCES_MAP[DEFAULT_INTERVIEW_ASSESSMENT_ID].assessmentCutoffs = await getAssessmentCutoffs(
        auth,
        DEFAULT_INTERVIEW_ASSESSMENT_ID
      );
      const questionCodes = [];
      target.interviewCompetencies.variableKeys.forEach((key) => {
        questionCodes.push(key);
      });
      const questionCutoffs = await getCodesCutoffs(auth, DEFAULT_INTERVIEW_ASSESSMENT_ID, questionCodes);
      CODE_RESOURCES_MAP[DEFAULT_INTERVIEW_ASSESSMENT_ID] = {};
      const assessmentCodeResources = CODE_RESOURCES_MAP[DEFAULT_INTERVIEW_ASSESSMENT_ID];
      Object.keys(questionCutoffs).forEach((key) => {
        assessmentCodeResources[key] = questionCutoffs[key];
      });
    }
  }
};
const getAssessmentResources = (target, assessmentId) => {
  return ASSESSMENT_RESOURCES_MAP[assessmentId];
};

const getCodeResources = (assessmentId, code) => {
  if (CODE_RESOURCES_MAP[assessmentId]) {
    return CODE_RESOURCES_MAP[assessmentId][code];
  }
  return undefined;
};

export const retrieveAssessmentCutoffs = async (auth, target) => {
  await retrieveCompetenciesCutoffs(auth, target);
  await retrieveInterviewCutoffs(auth, target);
  await retrieveExperienceCutoffs(auth, target);
  await retrieveSituationalJudgmentCutoffs(auth, target);
  await retrieveValuesCutoffs(auth, target);
};

export const getCompetenciesSummaryText = (target) => {
  const assessmentId = target.selfCompetencies.assessmentId;

  if (assessmentId !== DEFAULT_COMPETENCIES_ASSESSMENT_ID) {
    const assessmentResources = getAssessmentResources(target, assessmentId);
    if (assessmentResources?.assessmentCutoffs?.summaries) {
      const value = target.selfCompetencies.scores.overallLeadership;
      const summaries = assessmentResources.assessmentCutoffs.summaries[REPORT_TYPE.development];
      for (let c = 0; c < summaries.length; c++) {
        const summary = summaries[c];
        if (value >= summary.breakpoint) {
          return summary.text;
        }
      }
    }
  }

  return getDefaultCompetenciesOverallTextLocalResource(target);
};

export const getInterviewSummaryText = (target) => {
  const assessmentResources = getAssessmentResources(target, DEFAULT_INTERVIEW_ASSESSMENT_ID);
  if (assessmentResources?.assessmentCutoffs) {
    const value = target.interviewCompetencies.scores.overall;
    const summaries = assessmentResources.assessmentCutoffs.summaries[REPORT_TYPE.coaching];
    for (let c = 0; c < summaries.length; c++) {
      const summary = summaries[c];
      if (value >= summary.breakpoint) {
        return summary.text;
      }
    }
  }

  return getDefaultCompetenciesOverallTextLocalResource(target);
};

export const getCompetenciesTitle = (target, key) => {
  const assessmentId = target.selfCompetencies?.assessmentId;
  if (assessmentId === DEFAULT_COMPETENCIES_ASSESSMENT_ID) {
    return getDefaultCompetenciesTitle(key);
  }

  const codeResources = getCodeResources(assessmentId, key + '_S');
  if (codeResources) {
    return codeResources.title;
  }
};

export const getInterviewTitle = (target, key) => {
  const codeResources = getCodeResources(DEFAULT_INTERVIEW_ASSESSMENT_ID, key);
  if (codeResources) {
    return codeResources.title;
  }

  return getDefaultCompetenciesTitle(key);
};

export const getExperienceTitle = (target, key) => {
  const assessmentId = target.experience?.assessmentId;

  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    return codeResources.title;
  }
};

export const getSituationalJudgmentTitle = (target, key) => {
  const assessmentId = target.situationalJudgment?.assessmentId;

  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    return codeResources.title;
  }
};

export const getValuesTitle = (target, key) => {
  const assessmentId = target.values?.assessmentId;

  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    return codeResources.title;
  }
};

export const getCompetenciesSummary = (target, key) => {
  const newTarget = { ...target };

  // Since the Develop product was originally design to require raters to assess the target, downstream
  // code expects raterCompetencies to exist. This is somewhat hackish, but it addresses the issue in
  // accessing the verbiage associated when there are no rater competencies.
  if (!newTarget.raterCompetencies?.scores) {
    newTarget.raterCompetencies = {
      ...newTarget.raterCompetencies,
      scores: { ...newTarget.selfCompetencies.scores },
    };
  }

  const assessmentId = newTarget.selfCompetencies?.assessmentId;

  if (assessmentId === DEFAULT_COMPETENCIES_ASSESSMENT_ID) {
    return getDefaultCompetenciesSummary(newTarget, key);
  }

  const codeResources = getCodeResources(assessmentId, key + '_S');
  if (codeResources && newTarget.raterCompetencies?.scores?.[key]) {
    const value = newTarget.raterCompetencies.scores[key];
    const comments = codeResources.comments[REPORT_TYPE.development];
    for (let c = 0; c < comments.length; c++) {
      const summary = comments[c];
      if (value >= summary.breakpoint) {
        return summary.comment;
      }
    }
  }
};

export const getInterviewSummary = (target, key) => {
  const codeResources = getCodeResources(DEFAULT_INTERVIEW_ASSESSMENT_ID, key);
  if (codeResources) {
    const value = target.interviewCompetencies.scores[key];
    const comments = codeResources.comments[REPORT_TYPE.coaching];
    for (let c = 0; c < comments.length; c++) {
      const summary = comments[c];
      if (value >= summary.breakpoint) {
        return summary.comment;
      }
    }
  }

  return getDefaultCompetenciesSummary(target, key);
};

export const getExperienceSummary = (target, key) => {
  const assessmentId = target.experience?.assessmentId;

  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    const value = target.experience.scores[key];
    const comments = codeResources.comments[REPORT_TYPE.staffing];
    for (let c = 0; c < comments.length; c++) {
      const summary = comments[c];
      if (value >= summary.breakpoint) {
        return summary.comment;
      }
    }
  }
};

export const getSituationalJudgmentSummary = (target, key) => {
  const assessmentId = target.situationalJudgment?.assessmentId;

  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    const value = target.situationalJudgment.scores[key];
    const comments = codeResources.comments[REPORT_TYPE.staffing];
    for (let c = 0; c < comments.length; c++) {
      const summary = comments[c];
      if (value >= summary.breakpoint) {
        return summary.comment;
      }
    }
  }
};

export const getValuesSummary = (target, key) => {
  const assessmentId = target.values?.assessmentId;

  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    const value = target.values.scores[key];
    const comments = codeResources.comments[REPORT_TYPE.staffing];
    for (let c = 0; c < comments.length; c++) {
      const summary = comments[c];
      if (value >= summary.breakpoint) {
        return summary.comment;
      }
    }
  }
};

export const getCompetenciesCutoff = (target) => {
  const assessmentId = target.selfCompetencies.assessmentId;
  if (assessmentId === DEFAULT_COMPETENCIES_ASSESSMENT_ID) {
    return 4.25;
  }

  const assessmentResources = getAssessmentResources(target, assessmentId);
  if (assessmentResources?.assessmentCutoffs.breakpoints) {
    return assessmentResources.assessmentCutoffs.breakpoints.breaks[0];
  }
};

export const getInterviewCutoff = () => {
  const interviewBreakpoints = getInterviewBreakpoints();
  if (interviewBreakpoints) {
    return interviewBreakpoints.breaks[0];
  }

  return 3;
};

export const getSituationalJudgmentCutoff = (target) => {
  const assessmentId = target.situationalJudgment.assessmentId;
  const assessmentResources = getAssessmentResources(target, assessmentId);
  if (assessmentResources?.assessmentCutoffs.breakpoints) {
    return assessmentResources.assessmentCutoffs.breakpoints.breaks[0];
  }
};

export const getValuesCutoff = (target) => {
  const assessmentId = target.values.assessmentId;
  const assessmentResources = getAssessmentResources(target, assessmentId);
  if (assessmentResources?.assessmentCutoffs.breakpoints) {
    return assessmentResources.assessmentCutoffs.breakpoints.breaks[0];
  }
};

export const getCompetenciesBreakpoints = (target) => {
  const assessmentId = target.selfCompetencies.assessmentId;
  if (assessmentId === DEFAULT_COMPETENCIES_ASSESSMENT_ID) {
    return {
      breaks: [4.25, 3.0],
      scale: 5,
    };
  }

  const assessmentResources = getAssessmentResources(target, assessmentId);
  if (assessmentResources?.assessmentCutoffs.breakpoints) {
    return assessmentResources.assessmentCutoffs.breakpoints;
  }
};

export const getInterviewOverallBreakpoints = (target) => {
  const assessmentResources = getAssessmentResources(target, DEFAULT_INTERVIEW_ASSESSMENT_ID);
  if (assessmentResources?.assessmentCutoffs?.breakpoints?.length > 0) {
    return {
      breaks: assessmentResources.assessmentCutoffs.breakpoints.breaks.slice(1),
      scale: assessmentResources.assessmentCutoffs.breakpoints.scale,
    };
  }

  return {
    breaks: [23, 19],
    scale: 30,
  };
};

export const getInterviewBreakpoints = () => {
  const codeResources = getCodeResources(DEFAULT_INTERVIEW_ASSESSMENT_ID, 'INTERVIEW_1');
  if (codeResources) {
    const dimensionBreakpoints = {
      breaks: [],
      scale: 0,
    };

    codeResources.comments.forEach((comment) => {
      if (comment.breakpoint > 0) {
        dimensionBreakpoints.breaks.push(comment.breakpoint);
        if (comment.breakpoint > dimensionBreakpoints.scale) {
          dimensionBreakpoints.scale = comment.breakpoint;
        }
      }
    });

    dimensionBreakpoints.breaks.sort().reverse();

    return dimensionBreakpoints;
  }

  return { breaks: [3, 2], scale: 3 };
};

export const getExperienceBreakpoints = (target) => {
  const assessmentId = target.experience?.assessmentId;
  const assessmentResources = getAssessmentResources(target, assessmentId);
  if (assessmentResources?.assessmentCutoffs.breakpoints) {
    return assessmentResources.assessmentCutoffs.breakpoints;
  }
};

export const getSituationalJudgmentBreakpoints = (target) => {
  const assessmentId = target.situationalJudgment?.assessmentId;
  const assessmentResources = getAssessmentResources(target, assessmentId);
  if (assessmentResources?.assessmentCutoffs.breakpoints) {
    return assessmentResources.assessmentCutoffs.breakpoints;
  }
};

export const getValuesBreakpoints = (target) => {
  const assessmentId = target.values?.assessmentId;
  const assessmentResources = getAssessmentResources(target, assessmentId);
  if (assessmentResources?.assessmentCutoffs.breakpoints) {
    return assessmentResources.assessmentCutoffs.breakpoints;
  }
};

export const getCompetenciesTips = (target, key, reportType) => {
  const assessmentId = target.selfCompetencies?.assessmentId;
  if (assessmentId === DEFAULT_COMPETENCIES_ASSESSMENT_ID) {
    return getDefaultCompetenciesTips(target, key, reportType);
  }

  const codeResources = getCodeResources(assessmentId, key + '_S');
  if (codeResources) {
    const tips = codeResources.tips;
    return shuffleArray(target, tips);
  }
};

export const getInterviewTips = (target, key, development) => {
  const codeResources = getCodeResources(DEFAULT_INTERVIEW_ASSESSMENT_ID, key);
  if (codeResources) {
    const tips = codeResources.tips;
    if (tips?.length) {
      return shuffleArray(target, tips);
    }
  }

  return getDefaultCompetenciesTips(target, key, development);
};

export const getExperienceTips = (target, key, _reportType) => {
  const assessmentId = target.experience.assessmentId;
  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    const tips = codeResources.tips;
    if (tips?.length) {
      if (tips.length > 1) {
        return shuffleArray(target, tips);
      } else {
        return tips;
      }
    }
  }
};

export const getSituationalJudgmentTips = (target, key, _reportType) => {
  const assessmentId = target.situationalJudgment.assessmentId;
  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    const tips = codeResources.tips;
    if (tips?.length) {
      if (tips.length > 1) {
        return shuffleArray(target, tips);
      } else {
        return tips;
      }
    }
  }
};

export const getValuesTips = (target, key, _reportType) => {
  const assessmentId = target.values.assessmentId;
  const codeResources = getCodeResources(assessmentId, key);
  if (codeResources) {
    const tips = codeResources.tips;
    if (tips?.length) {
      if (tips.length > 1) {
        return shuffleArray(target, tips);
      } else {
        return tips;
      }
    }
  }
};
